import { useState, useEffect, useContext } from 'react';

import LiveReserveSituationLineLabel from './label/LiveReserveSituationLineLabel';
import LiveReserveSituationLineBatch from './batch/LiveReserveSituationLineBatch';
import LiveReserveSituationLineRadioBtn from './radioBtn/LiveReserveSituationLineRadioBtn';


// シチュエーションごと:選択行
function LiveReserveSituationCaseCategoryLine(props: any) {

  const category = props.category;
  const info = props.info;
  const isBusiness = props.isBusiness;

  const isDisabled = isBusiness;


  return (
    <li
      key={info.id}
      className="list-group-item"
      style={isBusiness? { backgroundColor: '#eeeeee' } : undefined}
    >
      {/* シチュエーション各行で表示するラベル：ミッション・台本 */}
      <LiveReserveSituationLineLabel
        info={info}
        isDisabled={isDisabled}
      />

      <label
        htmlFor={`situation_${category}_${info.id}`}
        style={{width: '90%', height: '100%', cursor: 'pointer',}}
      >

        {info.situation}

        {/* 各種バッチ */}
        <LiveReserveSituationLineBatch
          info={info}
        />

        {isDisabled && (
          <span
            className="pull-right"
            style={{fontWeight: 'normal', fontSize: '90%',}}
          >選択出来ません</span>
        )}
      </label>

      {/* シチュエーション各行で表示するラジオボタン */}
      <LiveReserveSituationLineRadioBtn
        category={category}
        info={info}
        isDisabled={isDisabled}
      />

    </li>
  );
}
  
export default LiveReserveSituationCaseCategoryLine;